import React from "react";
import SubNavbar from "../../components/otherComponents/SubNavBar/SubNavbar.js";
import QrCode from "../../components/otherComponents/qrCode/qrCode.js";
// Importación de Datos
import {
  giammariaCard__data,
  serviceCards__data,
} from "../../components/editComponents/cards/cardsData.js";
import {
  ITC_customEpoxyFloors,
  ITC_drywall,
  ITC_painting,
} from "../../components/editComponents/other/data_ImageAndTextContainer.js";

import ImageAndTextContainer from "../../components/otherComponents/ImageAndTextContainer/ImageAndTextContainer.js";
import CardsContainer from "../../components/containers/CardsContainer/CardsContainer.js";
import AllCards from "../../components/cards/AllCards.js";

function ServicesPage() {
  return (
    <div>
      {/* <SubNavbar />   Temporalmente sin funcion*/}
      <div id="CEF">
        <ImageAndTextContainer data={ITC_customEpoxyFloors} />
      </div>

      <CardsContainer
        scroll={true}
        marginTop={40}
        gapBetween={10}
        title={"Colors"}
        titlePosition={"Center"}
      >
        {giammariaCard__data.cards.map((card, index) => (
          <AllCards key={index} card={card} card__data={giammariaCard__data} />
        ))}
      </CardsContainer>
      {/* Contenedor del componente QR */}
      <div
        className="qrCodeInServices"
        style={{ textAlign: "center", marginTop: "20px" }}
      >
        <QrCode />
      </div>

      <div id="DW">
        <ImageAndTextContainer data={ITC_drywall} />
      </div>

      <div id="Pix">
        <ImageAndTextContainer data={ITC_painting} />
      </div>
    </div>
  );
}

export default ServicesPage;
